import { OfficePickupRule } from './remainsApi';

/**
 * The date rule at the point staff save (T-230). Only office pickup has a
 * transfer to wait for: a courier collects from the crematorium, and Ontario
 * pickups are at the crematorium itself. A day already on the case isn't
 * re-judged, so opening a case to fix its phone number doesn't demand a reason.
 */
export const pickupDayTooEarly = (input: {
  method?: string | null;
  day?: string | null;
  savedDay?: string | null;
  rule?: OfficePickupRule | null;
}): boolean => {
  const { method, day, savedDay, rule } = input;
  if (method !== 'office_pickup' || !day || !rule) return false;
  return day !== savedDay && day < rule.earliestDay;
};

/**
 * What the delivery editors must also write to `transfer_day`, which they used
 * to leave behind: case 932 had its pickup day cleared and kept a transfer for
 * Nov 3, so the courier ping would have called for a move nobody needed.
 */
export const transferDayPatch = (input: {
  method?: string | null;
  day?: string | null;
  savedMethod?: string | null;
  savedDay?: string | null;
  savedTransferDay?: string | null;
  courierBooked: boolean;
  rule?: OfficePickupRule | null;
}): { transfer_day?: string | null } => {
  const { method, day, savedMethod, savedDay, savedTransferDay, courierBooked, rule } = input;
  if (method === savedMethod && (day ?? null) === (savedDay ?? null)) return {};
  // The booked call carries its own day, and one call number covers the leg.
  if (courierBooked) return {};

  if (method === 'office_pickup') {
    if (!day) return { transfer_day: null };
    if (!rule?.soonestTransferDay) return {};
    return {
      transfer_day: rule.soonestTransferDay <= day ? rule.soonestTransferDay : day,
    };
  }
  if (method === 'crematorium_pickup' && day) return {};
  return savedTransferDay ? { transfer_day: null } : {};
};
